import { create } from 'zustand'
import {createJSONStorage, persist} from 'zustand/middleware'

interface UserState {
  userId: string | null
  shoppingPathJointId: string | null
  misc: string | null
  participationDate: string | null
}

interface UserActions {
  setUserData: (userId: string | null, shoppingPathJointId: string | null, misc: string | null, participationDate: string | null) => void
  resetUserData: () => void
}

type UserStore = UserState & UserActions

export const useUserStore = create<UserStore>()(
    persist(
        (set) => ({
            userId: null,
            shoppingPathJointId: null,
            misc: null,
            participationDate: null,
          setUserData: (userId, shoppingPathJointId, misc, participationDate) =>
              set({ userId, shoppingPathJointId, misc, participationDate }),

          resetUserData: () =>
              set({ userId: null, shoppingPathJointId: null, misc: null, participationDate: null }),
        }),
        {
          name: 'userInfo',
          storage: createJSONStorage(() => sessionStorage)
        },
    )
)